import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tabs, Table, message, Button, Icon, Modal, Spin } from 'antd';
import moment from 'moment';
import _get from 'lodash/get';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import PaymentModal from './Payment';
import { getExchangeBilling, getNewExchangeBilling, setExchangePlan, getExchange, putExchange, postContact, getPrice } from '../../common/fetch';
import { TABLE_BILLING_COLUMN } from '../../config/constants';
import {
	CURRENT_PLAN_CLOUD_ICON,
	DIY_ICON,
	BLUE_COG_SETTINGS_ICON,
	DIY_BOOST_ICON,
	CLOUD_PLAN_BASIC,
	CLOUD_PLAN_CRYPTO_PRO,
	CLOUD_PLAN_FIAT_RAMP
} from '../../config/media';
import ConfigurePlan, { planData } from '../ConfigurePlan';
import StakeConfigurePlan from '../StakeConfigurePlan';
import ContactUs from '../../components/ContactUs';
import Wrapper, { WarningWrapper, PlanModalWrapper } from './style';
import DataFilters from './FilterField';
// import EnterpriseForm from '../EnterpriseForm';
import { getCookie, getTabParams } from '../../common/utils';
import { Link } from 'react-router-dom';
import PluginActions from '../../actions/PluginAction';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { TabPane } = Tabs;

const Data = {
	basic: {
		// points: ['Cloud exchange server hosting', 'Locallization', 'Theme and color customization', 'Community support']
		description: 'Get started fast with a basic test exchange'
	},
	crypto: {
		// points: ['All feature in Basic', 'Standard email support', 'Custom domain', 'Remove hollaex branding', 'Basic team management & access control', 'User Chat/Trollbox']
		description: 'For those looking to start a crypto-to-crypto exchange business'
	},
	fiat: {
		// points: ['All feature in Standard', 'Priority support and service', 'Advance team management & access control', 'Advance server reliability', 'Landing page', 'custom GitHub repo integration (required for code customization)']
		description: 'For those that want to have the ultimate exchange experience and unlock all the premium features'
	}
};

// const ModalContent = Form.create({ name: 'EnterPriseForm' })(EnterpriseForm);

class Billing extends Component {
	constructor(props) {
		super(props);
		this.state = {
			exchangeId: null,
			isPayment: false,
			contentType: 'price',
			pendingInvoice: {},
			activeKey: '1',
			isMonthly: false,
			type: 'basic',
			headerType: '',
			isOpenPlanModal: false,
			// isEnterprise: false,
			priceData: {},
			isEdit: false,
			isContact: false,
			isLoading: false,
			hideBreadcrumb: false,
			isAutomatedKYC: false,
			tabParams: getTabParams(),
			isPendingPay: false,
			isPay: false,
			isSubscriptionLoading: false
		}
	}

	componentDidMount() {
		this.getData();
		let tabParams = getTabParams();
		// const urlParams = new URLSearchParams(window.location.search);
		// const myParam = urlParams.get('fiatSetup');
		// if (window.location.search.indexOf('fiatSetup') > -1 && myParam === 'true') {
		// 	if (window.history.pushState) {
		// 		var newURL = window.location.protocol + "//" + window.location.host + window.location.pathname;
		// 		window.history.pushState({ path: newURL }, '', newURL);
		// 	}
		// 	this.setState({
		// 		contentType: 'fiat-application',
		// 		isPayment: true,
		// 		hideBreadcrumb: true
		// 	});
		// }
		if (tabParams.tab) {
			this.setState({ activeKey: tabParams.tab });
		}
		if (this.state.tabParams
			&& this.state.tabParams.isPayment) {
			this.setState({
				isPayment: this.state.tabParams.isPayment === 'true',
				isAutomatedKYC: true
			});
		}
	}

	updateTabParams = (params, isPaid) => {
		let tabParams = getTabParams();
		if (isPaid) {
			this.handleDownload(params)
		} else {
			if (params) {
				this.setState({ tabParams: params, isPayment: true, isAutomatedKYC: true })
			} else {
				this.setState({ tabParams })
			}
		}
	};

	componentDidUpdate(prevProps, prevState) {
		if (this.props.activeTab !== prevProps.activeTab) {
			this.setActiveKey();
		}
		if (JSON.stringify(this.props.exchange) !== JSON.stringify(prevProps.exchange)) {
			this.setExchangeId();
		}
	}

	getData = async () => {
		await this.getInvoice({ is_paid: false });
		await this.getExchangePrice();
		this.setActiveKey();
		this.setExchangeId();
	};

	getTableData = (key) => {
		this.setState({ activeKey: key })
		if (key === "1") {
			this.getInvoice({ is_paid: false });
		} else {
			this.getInvoice({ is_paid: true });
		}
	};

	setActiveKey = () => {
		if (this.props.activeTab) {
			this.setState({ activeKey: this.props.activeTab });
		}
	};

	setExchangeId = () => {
		const { exchange, history } = this.props;
		if (exchange.length === 0) {
			history.push('/');
		} else if (exchange[0].id) {
			this.setState({ exchangeId: exchange[0].id })
		}
		if (exchange[0] && exchange[0].plan) {
			const exchangePlans = ['basic', 'crypto', 'fiat'];
			if (exchange[0].type === 'Cloud' && exchangePlans.includes(exchange[0].plan)) {
				this.setState({
					type: exchange[0].plan,
					isMonthly: exchange[0].period === 'month'
						? true
						: false
				});
			} else if (exchange[0].type === 'Cloud' && exchange[0].plan === 'boost') {
				this.setState({
					type: 'basic',
					isMonthly: exchange[0].period === 'month'
						? true
						: false
				});
			} else if (exchange[0].type === 'DIY' && exchange[0].plan === 'boost') {
				this.setState({
					type: exchange[0].plan
				});
			} else {
				this.setState({
					type: 'diy',
				});
			}
		}
	};

	updatePlanType = async (params, callback = () => { }) => {
		const { isBilling } = this.props
		try {
			if (!isBilling) {
				const res = await setExchangePlan(params);
				if (res.data) {
					this.getExchange();
					callback();
				}
			}
			if (this.props.exchange
				&& this.props.exchange[0]
				&& this.props.exchange[0].id
				// && params.plan !== "fiat"
			) {
				if (!isBilling) {
					const resInvoice = await getNewExchangeBilling(this.props.exchange[0].id);
					this.setState({ isSubscriptionLoading: false });
					if (resInvoice.data) {
						this.setState({ pendingInvoice: resInvoice.data });
						this.getInvoice();
					}
				} else {
					const { pluginData, pendingBilling } = this.props
					let pendingData = pendingBilling && pendingBilling.filter((pendingBill) => {
						return pendingBill.meta.activation && pendingBill.meta.activation.name === pluginData.name
					})
					if (pendingData.length) {
						this.setState({ pendingInvoice: pendingData[0] });
					}
					this.getInvoice();
				}
			}
		} catch (error) {
			console.error(error);
			this.setState({ isSubscriptionLoading: false });
			if (error.data && error.data.message) {
				message.error(error.data.message);
			} else {
				message.error(error.message);
			}
		}
	};

	getInvoice = async (params) => {
		this.setState({ isLoading: true });
		try {
			const res = await getExchangeBilling(params);
			if (res.data && res.data.data) {
				this.setState({ isSubscriptionLoading: false });
				const invoice = res.data.data.sort((a, b) => {
					const AD = new Date(a.created_at);
					const BD = new Date(b.created_at);
					return AD >= BD ? -1 : 1;
				});
				if (!params) {
					let paid = invoice.filter((val) => val.is_paid);
					let pending = invoice.filter((val) => !val.is_paid);
					this.props.storeBilling({ paidBilling: paid, pendingBilling: pending });
				} else if (params.is_paid) {
					this.props.storeBilling({ paidBilling: invoice });
				} else {
					this.props.storeBilling({ pendingBilling: invoice });
				}
				this.setState({ isLoading: false });
			}
		} catch (error) {
			console.error(error);
			if (error.data && error.data.message) {
				message.error(error.data.message);
			} else {
				message.error(error.message);
			}
			this.setState({ isLoading: false, isSubscriptionLoading: false });
		}
	};

	openPaymentModal = async () => {
		const exchange = this.props.exchange[0] || {};
		const { isBilling } = this.props;
		const { isEdit } = this.state;

		if (!isBilling && exchange.is_paid && exchange.expiry && moment().isAfter(moment(exchange.expiry))) {
			try {
				const resInvoice = await getNewExchangeBilling(exchange.id);
				if (resInvoice.data) {
					this.setState({
						pendingInvoice: resInvoice.data,
						isPayment: true,
						contentType: isEdit ? 'payment' : 'price'
					});
					this.getInvoice();
				}
			} catch (error) {
				console.error(error);
				if (error.data && error.data.message) {
					message.error(error.data.message);
				} else {
					message.error(error.message);
				}
			}
		} else {
			this.setState({
				isPayment: true,
				contentType: isEdit ? 'payment' : 'price',
			});
		}
		// handlePayment(true);
		// handleContent('price');
	};

	closePaymentModal = () => {
		const exchange = this.props.exchange[0] || {};
		const { UpdatePluginDetail } = this.props;
		UpdatePluginDetail(false);
		this.setState({
			isPayment: false,
			isMonthly: exchange.period === 'month'
				? true
				: false,
			isEdit: false,
			hideBreadcrumb: false,
			isAutomatedKYC: false,
			isPendingPay: false,
			isPay: false
		});
	};

	handleEdit = (id, isAutomatedKYC = false, isPendingPay = false) => {
		this.setState({ isPay: true });
		let pendingData = this.props.pendingBilling.filter(
			(val) => val.id === id
		);
		if (isAutomatedKYC) {
			this.props.UpdatePluginDetail(true);
		}
		if (pendingData.length) {
			let pendingInvoice = pendingData[0];
			this.setState({
				pendingInvoice,
				isEdit: true,
				isAutomatedKYC,
				isPendingPay
			}, () => {
				this.openPaymentModal();
			});
		}
	};

	handleToggle = (checked) => {
		// this.updatePlanType(
		// 	{
		// 		id: this.state.exchangeId,
		// 		plan: this.state.type,
		// 		period: checked ? 'month' : 'year'
		// 	},
		// 	() => {
		// 		this.setState({ isMonthly: checked });
		// 	}
		// );
		this.setState({ isMonthly: checked });
	};

	handleSelect = (type) => {
		// const { exchangeId, isMonthly } = this.state;
		// this.updatePlanType(
		// 	{
		// 		id: exchangeId,
		// 		plan: type,
		// 		period: isMonthly ? 'month' : 'year'
		// 	},
		// 	this.onCancelPlanModal
		// );
		this.setState({ type });
	};

	handleOpenPlanModal = (value) => {
		this.setState({
			isOpenPlanModal: true,
			headerType: value,
		});
	};

	onCancelPlanModal = () => {
		this.setState({ isOpenPlanModal: false, isAlert: false });
		const { UpdatePluginDetail } = this.props;
		UpdatePluginDetail(false);
	};

	handleAfterSubmit = () => {
		this.setState({
			isPayment: true,
			contentType: 'fiat-application',
			hideBreadcrumb: true
		});
	}

	renderCardButton = () => {
		// const { exchange = [] } = this.props;
		// const currentExchange = exchange[0] || {};
		// const isBusinessInfo = Object.keys(currentExchange.business_info).length > 0;
		// if (isBusinessInfo && currentExchange.plan === 'fiat') {
		// 	return (
		// 		<Button
		// 			type='primary'
		// 			className={"paid-btn"}
		// 			onClick={this.handleAfterSubmit}
		// 		>
		// 			<div className="d-flex align-center">
		// 				<Icon type="check-circle" theme="filled" />
		// 				<div>Submitted</div>
		// 			</div>
		// 		</Button>
		// 	)
		// } else {
		return (
			<Button
				type='primary'
				onClick={this.openPaymentModal}
			>
				Pay
			</Button>
		);
		// }
	}

	handleDownload = (invoice_id, i) => {
		const { exchange, paidBilling, pendingBilling, user } = this.props;
		let invoice = {};
		if (paidBilling.concat(pendingBilling)) {
			paidBilling.concat(pendingBilling).forEach(data => {
				if (data.id === invoice_id) {
					invoice = data;
				}
			});
		}
		let { id, amount, currency, item, description, is_paid, created_at } = invoice;
		let { phone_number, username, full_name, address, email } = user;

		address = `${address.address} \n ${address.city} ${address.postal_code} \n ${address.country}`; // set the full address

		if (!id) id = '';
		if (!amount) amount = '';
		if (!currency) currency = '';
		if (!item) item = '';
		if (!description) description = '';
		if (!is_paid) is_paid = false;
		if (!created_at) created_at = '';
		if (!phone_number) phone_number = '';
		if (!username) username = '';
		if (!full_name) full_name = '';
		if (!address) address = '';

		pdfMake.fonts = {
			'Roboto' : {
			   normal: 'Roboto-Regular.ttf',
			   bold: 'Roboto-Medium.ttf',
			   italics: 'Roboto-Italic.ttf',
			   bolditalics: 'Roboto-Italic.ttf'
			},
		 
			'OpenSans' : {
			   normal: 'OpenSans-Regular.ttf',
			   bold: 'OpenSans-Medium.ttf',
			   italics: 'OpenSans-Italic.ttf',
			   bolditalics: 'OpenSans-Italic.ttf'
			}
		 
		 }

		const pdfDoc = {
			content: [
				{
					columns: [
						{
							svg: `<svg version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
							x="0px" y="0px" viewBox="0 0 110 50" overflow="visible" xml:space="preserve">
					   <g id="Component_22_16" transform="translate(0 0)">
						   <path id="Path_1686" d="M105.1,44.4V5.7H4.9v38.6h76.9H101l-4.3-4.2H9V9.8h92v34.6H105.1z"/>
						   <g id="Group_284" transform="translate(10.665 9.884)">
							   <path id="Path_1720" d="M5.1,6.7h4.5v5.7h4.8V6.7h4.5v15.5h-4.5v-6.1H9.6v6.1H5.1V6.7z"/>
							   <path id="Path_1721" d="M19.8,16.7c-0.1-3.3,2.5-6.1,5.8-6.2c3.3-0.1,6.1,2.5,6.2,5.8s-2.5,6.1-5.8,6.2c-0.1,0-0.1,0-0.2,0
								   c-3.1,0.2-5.8-2.2-6-5.3C19.8,17.1,19.8,16.9,19.8,16.7z M27.8,16.7c0-1.9-0.6-3.1-1.9-3.1S24,14.8,24,16.7s0.6,3.1,1.9,3.1
								   S27.8,18.6,27.8,16.7L27.8,16.7z"/>
							   <path id="Path_1722" d="M32.7,6.7h4.2v15.5h-4.2V6.7z"/>
							   <path id="Path_1723" d="M38.1,6.7h4.2v15.5h-4.2V6.7z"/>
							   <path id="Path_1724" d="M50,21L50,21c-0.8,1-2.1,1.6-3.4,1.5c-2.1,0-3.7-1.1-3.7-3.3c0-2.4,1.9-3.2,4-3.4c2.3-0.3,3-0.5,3-1.2
								   c0-0.6-0.3-1.1-1.2-1.1c-0.7-0.1-1.4,0.5-1.4,1.3c0,0,0,0,0,0.1h-3.9c0.1-2.2,1.8-4,5.2-4c1.2-0.1,2.5,0.2,3.6,0.7
								   c1.1,0.7,1.8,2,1.7,3.3v5.5c0,0.9,0.1,1.4,0.4,1.6v0.2h-4C50.2,21.8,50.1,21.4,50,21z M50.1,18.2v-1c-0.5,0.2-1,0.4-1.6,0.5
								   c-1.2,0.3-1.6,0.6-1.6,1.3c0,0.7,0.6,1.1,1.3,1.1c1,0.1,1.8-0.6,1.9-1.6C50.1,18.4,50.1,18.3,50.1,18.2z"/>
							   <path id="Path_1725" d="M55.5,6.7h12v3.7H60v2.1h6.3v3.4H60v2.4h7.7v3.9H55.5V6.7z"/>
							   <path id="Path_1726" d="M71.9,16.5l-3.4-5.3h4.7l1.3,2.5l0,0l1.3-2.5h4.3L77,16.4l3.6,5.8h-4.7l-1.6-2.9l0,0l-1.6,2.9h-4.5
								   L71.9,16.5z"/>
							   <path id="Path_1727" d="M82.7,22.2c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8l0,0C84.5,21.4,83.7,22.2,82.7,22.2z
									M82.7,18.8c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C84.3,19.5,83.6,18.8,82.7,18.8z"/>
							   <path id="Path_1728" d="M82,19.5h0.8c0.3,0,0.6,0.2,0.6,0.5c0,0.2-0.1,0.3-0.3,0.4l0,0c0.1,0,0.2,0.1,0.2,0.3c0,0.2,0,0.4,0.1,0.4
								   l0,0h-0.5c0,0,0-0.2-0.1-0.4c0-0.1-0.1-0.2-0.2-0.2h-0.2v0.6H82V19.5z M82.5,20.2h0.3c0.1,0,0.2-0.1,0.2-0.2s-0.1-0.2-0.2-0.2
								   h-0.3V20.2z"/>
						   </g>
					   </g>
					   </svg>`,
							width: 100,
						},
						[
							{
								text: 'Invoice	',
								color: '#333333',
								width: '*',
								fontSize: 28,
								bold: true,
								alignment: 'right',
								margin: [0, 0, 0, 15],
							},
							{
								stack: [
									{
										columns: [
											{
												text: 'Invoice No.',
												color: '#aaaaab',
												bold: true,
												width: '*',
												fontSize: 10,
												alignment: 'right',
											},
											{
												text: id,
												bold: true,
												color: '#333333',
												fontSize: 10,
												alignment: 'right',
												width: 100,
											},
										],
									},
									{
										columns: [
											{
												text: 'Date Issued',
												color: '#aaaaab',
												bold: true,
												width: '*',
												fontSize: 10,
												alignment: 'right',
											},
											{
												text: !created_at ? '' : moment(created_at).format('MMMM D, YYYY'),
												bold: true,
												color: '#333333',
												fontSize: 10,
												alignment: 'right',
												width: 100,
											},
										],
									},
									{
										columns: [
											{
												text: 'Status',
												color: '#aaaaab',
												bold: true,
												fontSize: 10,
												alignment: 'right',
												width: '*',
											},
											{
												text: is_paid ? 'PAID' : 'UNPAID',
												bold: true,
												fontSize: 10,
												alignment: 'right',
												color: 'green',
												width: 100,
											},
										],
									},
								],
							},
						],
					],
				},
				{
					columns: [
						{
							text: 'From',
							color: '#aaaaab',
							bold: true,
							fontSize: 10,
							alignment: 'left',
							margin: [0, 20, 0, 5],
						},
						{
							text: 'To',
							color: '#aaaaab',
							bold: true,
							fontSize: 10,
							alignment: 'left',
							margin: [0, 20, 0, 5],
						},
					],
				},
				{
					columns: [
						{
							text: `HollaEx \n HLX Global Ltd. \n 28F, 9 Battery Road, #28-01 \n Singapore 049910 \n Singapore`,
							color: '#333333',
							alignment: 'left',
							fontSize: 8,
							margin: [0, 0, 0, 30]
						},
						{
							text: full_name + '\n' + email + '\n' + address,
							color: '#333333',
							alignment: 'left',
							fontSize: 8,
						},
					],
				},
				{
					layout: {
						defaultBorder: false,
						hLineWidth: function (i, node) {
							return 1;
						},
						vLineWidth: function (i, node) {
							return 1;
						},
						hLineColor: function (i, node) {
							if (i === 1 || i === 0) {
								return '#888';
							}
							return '#eaeaea';
						},
						vLineColor: function (i, node) {
							return '#eaeaea';
						},
						hLineStyle: function (i, node) {
							// if (i === 0 || i === node.table.body.length) {
							return null;
							//}
						},
						// vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
						paddingLeft: function (i, node) {
							return 10;
						},
						paddingRight: function (i, node) {
							return 10;
						},
						paddingTop: function (i, node) {
							return 2;
						},
						paddingBottom: function (i, node) {
							return 2;
						},
						fillColor: function (rowIndex, node, columnIndex) {
							return '#fff';
						},
					},
					table: {
						headerRows: 1,
						widths: [80, '*', 80],
						margin: [10, 0, 0, 0],
						body: [
							[
								{
									text: 'Item',
									fillColor: '#eeeeee',
									border: [false, true, false, true],
									margin: [0, 5, 0, 5],
									fontSize: 10,
								},
								{
									text: 'Description',
									fillColor: '#eeeeee',
									border: [false, true, false, true],
									margin: [0, 5, 0, 5],
									fontSize: 10,
								},
								{
									text: 'Total',
									border: [false, true, false, true],
									alignment: 'right',
									fillColor: '#eeeeee',
									margin: [0, 5, 0, 5],
									fontSize: 10,
								},
							],
							[
								{
									text: 'Exchange Subscription',
									border: [false, false, false, true],
									margin: [0, 5, 0, 5],
									fontSize: 9,
									alignment: 'left',
								},
								{
									text: `${description} (${item})`,
									border: [false, false, false, true],
									margin: [0, 5, 0, 5],
									fontSize: 9,
									alignment: 'left',
								},
								{
									border: [false, false, false, true],
									text: '$' + amount,
									alignment: 'right',
									margin: [0, 5, 0, 5],
									fontSize: 9,
								},
							],
						],
					},
				},
				{
					layout: {
						defaultBorder: false,
						hLineWidth: function (i, node) {
							return 1;
						},
						vLineWidth: function (i, node) {
							return 1;
						},
						hLineColor: function (i, node) {
							return '#eaeaea';
						},
						vLineColor: function (i, node) {
							return '#eaeaea';
						},
						hLineStyle: function (i, node) {
							// if (i === 0 || i === node.table.body.length) {
							return null;
							//}
						},
						// vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
						paddingLeft: function (i, node) {
							return 10;
						},
						paddingRight: function (i, node) {
							return 10;
						},
						paddingTop: function (i, node) {
							return 3;
						},
						paddingBottom: function (i, node) {
							return 3;
						},
						fillColor: function (rowIndex, node, columnIndex) {
							return '#fff';
						},
					},
					table: {
						headerRows: 1,
						widths: ['*', 'auto'],
						body: [
							[
								{
									text: 'Subtotal',
									border: [false, true, false, true],
									alignment: 'right',
									margin: [0, 5, 0, 5],
									fontSize: 10,
								},
								{
									border: [false, true, false, true],
									text: '$' + amount,
									alignment: 'right',
									margin: [0, 5, 0, 5],
									fontSize: 10,
								},
							],
							[
								{
									text: 'Total Amount',
									bold: true,
									fontSize: 11,
									alignment: 'right',
									border: [false, false, false, true],
									margin: [0, 5, 0, 5],
								},
								{
									text: '$' + amount,
									bold: true,
									fontSize: 11,
									alignment: 'right',
									border: [false, false, false, true],
									fillColor: '#f5f5f5',
									margin: [0, 5, 0, 5],
								},
							],
						],
					},
				},
				{
					columns: [
						{
							text: 'Disclaimer: No Refunds. The Company does not offer any money-back guarantees. Client recognizes and agrees that he/she shall not be entitled to a refund for any purchase under any circumstances. Company makes no warranties regarding the performance, operation or suitability of its software and services. Company further makes no representation or warranties of any kind, express or implied and will not be liable for any damages caused.',
							color: '#444',
							alignment: 'left',
							fontSize: 7,
							margin: [0, 60, 0, 0]
						}
						
					]
				}
			],
			styles: {
				notesTitle: {
					fontSize: 10,
					bold: true,
					margin: [0, 50, 0, 3],
				},
				notesText: {
					fontSize: 10,
				},
			},
			defaultStyle: {
				columnGap: 20,
				font: 'Roboto'
			},
		};
		pdfMake.createPdf(pdfDoc).download(`hollaex_invoice_${exchange[0].name}_${invoice_id}.pdf`);
	};

	renderCard = () => {
		const {
			exchange = []
		} = this.props;
		const {
			type,
			isMonthly,
			isLoading,
			priceData
		} = this.state;
		const selectedPlan = Data[type] || {};
		const selectedPlanData = planData[type] || {};
		const selectedPlanPriceData = priceData[type] || {};
		const currentExchange = exchange[0] || {};
		if (currentExchange.type === 'Cloud') {
			return (
				<div className='box-container'>
					<div className={isLoading ? null : type === "basic" ? 'card-design basic-color' : (type === "crypto" ? 'card-design crypto-color' : 'card-design fiat-color')}></div>
					<div className={isLoading ? 'card-wrapper initial-card' : type === "basic" ? 'card-wrapper basic-plan' : (type === "crypto" ? 'card-wrapper crypto_pro-plan' : 'card-wrapper fiat_master-plan')}>
						<div className="d-flex f-1 flex-content">
							<div className='img-center'>
								{!isLoading && <img
									src={type === "basic" ? CLOUD_PLAN_BASIC : type === "crypto" ? CLOUD_PLAN_CRYPTO_PRO : CLOUD_PLAN_FIAT_RAMP}
									alt='cloud-icon'
									className='cloud-icon'
								/>}
							</div>
							{isLoading
								?
								<Spin />
								:
								<div className='content-align'>
									<div className="card-title">
										<div>
											<span className="cloud-label">Cloud:</span> {_get(selectedPlanData, 'title', '')}
										</div>
										{currentExchange.is_paid
											? <div
												className='plan-wrapper'
												onClick={this.handleOpenContact}
											>
												<div className="d-flex">
													<div>Configure{' '}</div>
													<img
														src={BLUE_COG_SETTINGS_ICON}
														alt='plan'
														className='plan-icon'
													/>
												</div>
											</div>
											: null
										}
									</div>
									{currentExchange.is_paid && type !== "fiat"
										? (
											<div>
												<div>
													{/* Plan: {isMonthly
														? `$${selectedPlanData.amount.monthly} paid monthly`
														: `$${(selectedPlanData.amount.yearly * 12)} paid yearly`
													} */}
													Plan: {isMonthly
														? _get(selectedPlanPriceData, 'month.price')
															? `$${_get(selectedPlanPriceData, 'month.price')} paid monthly` : ""
														: _get(selectedPlanPriceData, 'year.price')
															? `$${_get(selectedPlanPriceData, 'year.price')} paid yearly` : ""
													}
												</div>
												{(currentExchange.expiry && currentExchange.type !== 'DIY')
													? <div>Next payment: {moment(currentExchange.expiry).format('DD/MM/YYYY')}</div>
													: null
												}
											</div>
										)
										: (
											// <ul className='list-text'>
											// 	{selectedPlan.points.map((val, index) => {
											// 		return <li key={index}>{val}</li>;
											// 	})}
											// </ul>
											selectedPlan.description
										)
									}
								</div>
							}
						</div>
					</div>
					<div className='card-divider'></div>
					<div className='card-sub-content'>
						{currentExchange.is_paid && moment().isBefore(moment(currentExchange.expiry))
							? (
								<Fragment>
									<div
										className='anchor'
										onClick={() => this.setState({ activeKey: '2' })}
									>
										View last bill
									</div>
									<Button type='primary' className="paid-btn">
										<div className="d-flex align-center flex-content">
											<Icon type="check-circle" theme="filled" />
											<div>Paid</div>
										</div>
									</Button>
								</Fragment>
							)
							: (
								<Fragment>
									<div></div>
									{this.renderCardButton()}
								</Fragment>
							)
						}
					</div>
				</div>
			);
		}
		return (
			<div className='box-container'>
				<div className={'card-wrapper DIY-boost-bg'}>
					<div className="d-flex flex-content">
						<div className='image-container'>
							<div className="diy-icon-circle">
								<img
									src={type === 'boost' ? DIY_BOOST_ICON : DIY_ICON}
									alt='cloud-icon'
									className='cloud-icon'
								/>
							</div>
						</div>
						<div className='content-align'>
							<div className="card-title">
								{type === 'boost'
									?
									<div className="cloud-label">
										Boost
									</div>
									:
									<div className="cloud-label">
										Do-it-yourself
									</div>
								}
								<div
									className='plan-wrapper'
									onClick={() => this.handleOpenPlanModal('ConfigurePlan')}
								>
									<div className="d-flex">
										<div>Configure plan{' '}</div>
										<img
											src={BLUE_COG_SETTINGS_ICON}
											alt='plan'
											className='plan-icon'
										/>
									</div>
								</div>
							</div>
							{type === 'boost'
								?
								<div className="small-text">
									For expert DIY exchange operators seeking more. Comes fully featured out with reduced revenue sharing, one free custom token and market.
								</div>
								:
								<div className="small-text">
									For tech savvy people that know their way around a server and can self-host their exchange.
								</div>
							}
						</div>
					</div>
				</div>
				<div className='card-divider'></div>
				<div className='card-sub-content'>
					{currentExchange.is_paid && moment().isBefore(moment(currentExchange.expiry))
						? (
							<Fragment>
								<a href="https://github.com/hollaex/hollaex-kit/archive/master.zip" className='anchor'>Download Kit</a>
								<Button type='primary' className="paid-btn">
									<div className="d-flex align-center">
										<Icon type="check-circle" theme="filled" />
										<div>Paid</div>
									</div>
								</Button>
							</Fragment>
						)
						: (
							<Fragment>
								<a href="https://github.com/hollaex/hollaex-kit/archive/master.zip" className='anchor'>Download Kit</a>
								<div></div>
								<Button
									type='primary'
									className="stake-XHT-btn"
									onClick={this.openPaymentModal}
								>
									Boost
								</Button>
							</Fragment>
						)
					}
					<Fragment>


					</Fragment>
				</div>
			</div>
		);
	};

	getExchange = async () => {
		try {
			const res = await getExchange();
			const exchange = res.data.data.sort((a, b) => {
				const ad = new Date(a.updated_at);
				const bd = new Date(a.updated_at);
				if (Math.floor(ad - bd) >= 0) {
					return a - b;
				} else {
					return b - a;
				}
			});

			this.props.storeExchange(exchange);
		} catch (error) {
			if (error && error.data) {
				message.error(error.data.message)
			}
		}
	};

	handleProceed = async (type) => {
		const { exchange, actions } = this.props;
		const currentExchange = exchange[0] || {};
		if (type === currentExchange.type) {
			this.onCancelPlanModal();
		} else if (currentExchange.is_running) {
			this.setState({ isAlert: true });
		} else {
			try {
				const exchangeBody = {
					id: currentExchange.id,
					info: {
						tech: { SERVER_TYPE: type }
					},
					type
				};
				await putExchange(exchangeBody);
				message.success('Updated successfully');
				this.getExchange();
				// if (type === "Enterprise") {
				// 	this.setState({ isEnterprise: true })
				// } else {
				// 	this.setState({ isEnterprise: false })
				//  this.onCancelPlanModal();
				// }
				// if (currentExchange.is_running) {
				// 	if (type === "Enterprise") {
				// 		this.setState({ isAlert: true })
				// 	}
				// }
				actions.updateTech({ SERVER_TYPE: type, type });

			} catch (error) {
				console.error(error);
				if (error.data && error.data.message) {
					message.error(error.data.message);
				}
			}
		}
	};

	submitEnterprise = async (formProps) => {
		const data = {
			email: getCookie('email'),
			category: 'enterprise',
			subject: 'enterprise exchange',
			description: JSON.stringify(formProps)
		};
		try {
			const res = await postContact(data);
			message.success(res.message);
			this.onCancelPlanModal();
		} catch (error) {
			if (error.data && error.data.message) {
				message.error(error.data.message);
			}
		}
	};

	getExchangePrice = async () => {
		this.setState({ isLoading: true });
		try {
			const res = await getPrice();
			let priceData = {};
			Object.keys(res.data).forEach((key) => {
				let temp = res.data[key];
				if (!temp.month) {
					temp.month = {};
				}
				if (!temp.year) {
					temp.year = {};
				}
				priceData[key] = { ...temp };
			});
			this.setState({ priceData });
			this.setState({ isLoading: false });
		} catch (error) {
			if (error.data && error.data.message) {
				message.error(error.data.message);
				this.setState({ isLoading: false });
			}
		}
	}

	renderPopup = () => {
		const { exchange = [] } = this.props;
		const {
			isMonthly,
			headerType,
			// isEnterprise,
			priceData,
			isAlert
		} = this.state;
		const currentExchange = exchange[0] || {};


		if (isAlert) {
			return (
				<WarningWrapper>
					<div className="message">
						Can't configure plan on a live exchange. Contact support@hollaex.com for assistance.
					</div>
					<Button type="primary" onClick={this.onCancelPlanModal}>Close</Button>
				</WarningWrapper>
			)
		}
		if (currentExchange.type === "Cloud") {
			return <PlanModalWrapper>
				<ConfigurePlan
					priceData={priceData}
					exchange={currentExchange}
					isMonthly={isMonthly}
					planType={headerType}
					handleSelect={this.handleSelect}
					handleToggle={this.handleToggle}
					handleClose={this.onCancelPlanModal}
				/>
			</PlanModalWrapper>
		}
		//  else if (isEnterprise) {
		// 	return <EnterPriseWrapper>
		// 		<ModalContent
		// 			onSubmitEnterprise={this.submitEnterprise}
		// 		/>
		// 	</EnterPriseWrapper>

		// } 
		else {
			return <StakeConfigurePlan
				exchange={currentExchange}
				handleProceed={this.handleProceed}
			/>
		}
	}

	handleOpenContact = () => {
		this.setState({ isContact: true });
	};

	handleContactClose = () => {
		this.setState({ isContact: false });
	};
	handleOk = (data) => {
		message.success(data);
		this.handleContactClose();
	};
	handleError = (error) => {
		message.error(error);
		this.handleContactClose();
	};

	handleLoading = () => {
		this.setState({ isSubscriptionLoading: true });
	}

	render() {
		const {
			exchange = [],
			paidBilling = [],
			pendingBilling = [],
			history,
			activeTab = '1',
			user,
			storeExchange,
			isBilling
		} = this.props;
		const {
			type,
			// activeKey,
			isPayment,
			isMonthly,
			contentType,
			pendingInvoice,
			isOpenPlanModal,
			// isEnterprise,
			priceData,
			headerType,
			isEdit,
			isContact,
			hideBreadcrumb,
			isAutomatedKYC,
			tabParams,
			isPendingPay,
			isPay,
			isSubscriptionLoading
		} = this.state;
		const currentExchange = exchange[0] || {};
		return (
			<Wrapper>
				<div className='main-header'>Billings</div>
				<div className='content-panel'>
					<div className='wrapper-container'>
						<div className='divider'>
							<h3>Current plan</h3>
							<div className='d-flex flex-content'>
								<div className='image-container'>
									<img
										src={CURRENT_PLAN_CLOUD_ICON}
										alt='cloud-icon'
										className='cloud-icon-normal'
									/>
								</div>
								<div className='pading-left'>
									<div className={currentExchange.type === 'Cloud' ? '' : 'c-plan'}>
										Below is your current plan. Get more details on the available{' '}
										<span className='anchor' onClick={this.handleOpenPlanModal}>
											cloud plans
										</span>.
									</div>
									{currentExchange.type === 'Cloud'
										?
										<div>
											Want to switch to on-premise? Visit the {' '}
											<Link to={'/hosting'}>hosting page.</Link>
										</div>
										: null
									}
								</div>
							</div>
						</div>
						<div className='card-container'>
							{this.renderCard()}
						</div>
					</div>
					<Tabs
						defaultActiveKey={activeTab}
						// activeKey={activeKey}
						onChange={this.getTableData}
					>
						<TabPane tab='Pending' key='1'>
							<div className='filter'>
								<DataFilters />
							</div>
							<div className="table-wrapper">
								<Table
									columns={TABLE_BILLING_COLUMN(
										currentExchange,
										this.handleEdit,
										this.updateTabParams
									)}
									dataSource={pendingBilling}
									rowKey={(data) => {
										return data.id;
									}}
								/>
							</div>
						</TabPane>
						<TabPane tab='Paid' key='2'>
							<div className='filter'>
								<DataFilters />
							</div>
							<div className="table-wrapper">
								<Table
									columns={TABLE_BILLING_COLUMN(
										currentExchange,
										this.handleEdit,
										this.handleDownload
									)}
									dataSource={paidBilling}
									rowKey={(data) => {
										return data.id;
									}}
								/>
							</div>
						</TabPane>
					</Tabs>
				</div>
				{(isPayment || isBilling) && (
					<PaymentModal
						isEdit={isEdit}
						balance={user.balance || {}}
						priceData={priceData}
						history={history}
						isOpen={isPayment}
						invoiceData={pendingInvoice}
						exchange={currentExchange}
						type={type}
						isMonthly={isMonthly}
						contentType={contentType}
						headerType={headerType}
						getInvoice={this.getInvoice}
						onOk={this.openPaymentModal}
						onCancel={this.closePaymentModal}
						handleSelect={this.handleSelect}
						handleToggle={this.handleToggle}
						handleOpenPlanModal={this.handleOpenPlanModal}
						onCancelPlanModal={this.onCancelPlanModal}
						updatePlanType={this.updatePlanType}
						hideBreadcrumb={hideBreadcrumb}
						actions={storeExchange}
						isAutomatedKYC={isAutomatedKYC}
						tabParams={tabParams}
						updateTabParams={this.updateTabParams}
						isPendingPay={isPendingPay}
						currentPage={'/billing'}
						isPay={isPay}
						isLoading={this.handleLoading}
						handleLoading={isSubscriptionLoading}
					/>
				)}
				<Modal
					visible={isOpenPlanModal}
					width={currentExchange.type === "Cloud" ? '50rem' : 450}
					zIndex={1000}
					onCancel={this.onCancelPlanModal}
					footer={null}
				>
					{this.renderPopup()}
					{/* {currentExchange.type === "Cloud"
						?
							<ConfigurePlan
								priceData={priceData}
								exchange={currentExchange}
								isMonthly={isMonthly}
								planType={headerType}
								handleSelect={this.handleSelect}
								handleToggle={this.handleToggle}
								handleClose={this.onCancelPlanModal}
							/>
						: 
						(isEnterprise
							?
								<EnterPriseWrapper>
									<ModalContent
										onSubmitEnterprise={this.submitEnterprise}
									/>
								</EnterPriseWrapper>
							: 
								<StakeConfigurePlan 
									exchange={currentExchange}
									handleProceed={this.handleProceed}
								/>
						)
					} */}
				</Modal>
				{isContact
					? <ContactUs
						visible={isContact}
						defaultType="Other"
						handleOk={this.handleOk}
						handleError={this.handleError}
						handleCancel={this.handleContactClose}
					/>
					: null
				}
			</Wrapper>
		);
	};
}

const mapStateToProps = (store) => {
	return {
		isBilling: store.plugin.isBilling,
		pluginData: store.plugin.pluginData
	}
}

const mapDispatchToProps = (dispatch) => ({
	UpdatePluginDetail: bindActionCreators(PluginActions.isBilling, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Billing);